import _getters from '@/store/modules/getters'
import _mutations from '@/store/modules/mutations'
import client from '@/base/api/client'
import SysUtils from '@/base/utils/SysUtils'

const mutations = Object.assign({}, _mutations)
const getters = Object.assign({}, _getters)

mutations.FRAMEFINISH = function (state, payload) {
  state.frameFinish = payload
}

const state = {
  rows: [],
  frameType: [],
  frameFinish: [],
  row: null,
  condition: {}
}

mutations.FRAMETYPE = function (state, payload) {
  state.frameType = payload
}
const actions = {
  init: ({ commit, state }) => {

  },
  reset: ({ commit, state }) => {
    console.debug('called reset')
    commit('FIND_ALL', '')
  },
  cancel: ({ commit, state }) => {
    console.debug('called M0001User cancel')
    commit('EDIT', null)
  },
  search: ({ commit, state }, condition) => {
    console.debug('called M0001User search')
    return client.postData({ data: { search: { api: 'M0002LandingPageService.searchDataDetails', input: condition } } })
      .then((data) => {
        if (SysUtils.isEmpty(data.search.output)) {
          alert('no match record')
        }
        commit('FIND_ALL', data.search.output)
      })
  },
  add: ({ commit, state }) => {
    console.debug('called M0001User add')
    commit('EDIT',
      {
        id: null,
        files: {}
        // relates: {},
        // belongs: {}
      }
    )
  },
  edit: ({ commit, state }, id) => {
    console.debug('called M0001User edit')
    return client.postData({ data: { find: { api: 'M0002LandingPageService.getDataDetails', input: {id: id, ':detail': 1} } } })
      .then((data) => {
        commit('EDIT', data.find.output)
      })
  },
  frameType: ({ commit, state }) => {
    console.debug('called M0001User edit')
    return client.postData({ data: { find: { api: 'M0002LandingPageService.getFrameTypeForSelect' }, finish: { api: 'M0002LandingPageService.getFrameFinishForSelect' } } })
      .then((data) => {
        commit('FRAMETYPE', data.find.output)
        commit('FRAMEFINISH', data.finish.output)
      })
  },
  delete: ({ commit, state }, row) => {
    console.debug('called M0001User delete')
    return client.postData({ data: { delete: { api: 'M0002LandingPageService.deleteData', input: row } } })
      .then((data) => {
        commit('EDIT', null)
      })
  },
  deleteImage: ({ commit, state }, item) => {
    console.debug('called M0001User delete')
    return client.postData({ data: { delete: { api: 'M0002LandingPageService.deleteImage', input: item } } })
      .then((data) => {
        commit('EDIT', data.delete.output)
      })
  },
  bulkDelete: ({ commit, state }, row) => {
    console.debug('called M0001User delete')
    return client.postData({ data: { delete: { api: 'M0002LandingPageService.deleteDataDetails', input: row } } })
      .then((data) => {
        commit('FIND_ALL', data.delete.output)
      })
  },
  save: ({ commit, state }, row) => {
    console.debug('called M0001User save')
    return client.postData({ data: { save: { api: 'M0002LandingPageService.saveDataDetails', input: row } } })
      .then((data) => {
        commit('SAVE', data.save.output)
      })
  },
  publishFrame: ({ commit, state }, row) => {
    console.debug('called M0001User save')
    return client.postData({ data: { save: { api: 'M0002LandingPageService.publishFrame', input: row } } })
      .then((data) => {
        // commit('SAVE', data.save.output)
      })
  }

}

const module = {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}

export default module
